<script setup lang="ts">
import type { ApiBlockGridArea, ElementItem } from "@edco/apollo";
import FadeGroupTransition from "~/components/transitions/FadeGroupTransition.vue";
import type { NestedGrid } from "~/models/generated/NestedGrid";

const props = defineProps<{
  content: ElementItem<NestedGrid>;
  settings: ElementItem;
}>();

const articleColumns = ref( 2 );

const style = computed( () => {
  if ( props.content.properties?.backgroundImage?.[0].url ) {
    return {
      backgroundImage: `url(${props.content.properties.backgroundImage?.[0].url})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      minHeight: "300px",
    };
  }
  return {};
} );

const classes = computed( () => {
  return props.content.properties.backgroundColor
    ? `bg-accent-${props.content.properties.backgroundColor.label}`
    : "no-bg";
} );
</script>

<template>
  <div
    :class="['nested-grid', classes]"
    :style="style">
    <div
      v-if="content.properties.grid"
      class="container">
      <section class="row">
        <div class="col">
          <template v-if="content.properties.heading">
            <!-- <h2>{{ content.properties.heading }}</h2> -->
          </template>
          <block-grid :content="content.properties.grid" />
        </div>
      </section>
    </div>

    <div
      v-if="content.properties.articles && content.properties.articles.length"
      class="articles">
      <div class="container">
        <section class="row justify-content-center">
          <div class="col">
            <fade-group-transition
              tag="ol"
              intersect
              class="nested-grid__articles-list">
              <li
                v-for="(article, index2) in content.properties.articles || []"
                :key="article.id"
                :data-index="index2"
                class="nested-grid__articles-item"
                :class="`article-search-results__item--${articleColumns}`">
                <!-- suppress RequiredAttributes -->
                <article-card
                  v-bind="article"
                  :max-tags="3" />
              </li>
            </fade-group-transition>
          </div>
        </section>
      </div>
    </div>

    <div
      v-if="(content.properties.guidelines?.items.length || 0) > 0"
      class="article-guidelines">
      <div class="container">
        <section class="row">
          <div class="col">
            <div class="nested-grid__guidelines">
              <ol>
                <li
                  v-for="(item, idx) in content.properties.guidelines?.items || []"
                  :key="`article-guideline-${idx}`">
                  <span class="nested-grid__guideline-no">
                    <span>{{ idx + 1 }}</span>
                  </span>
                  <sanitize-html :dirty="item.content.properties.guideline" />
                </li>
              </ol>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.richtext {background: #333;}
</style>
